export const getTabs = (state) => state.tabsSettings;